import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AboutPPLTz.css';

const AboutPPLTz = () => {
  const navigate = useNavigate();

  const brandIntroParagraph =
    "Parksons Packaging Tanzania Limited is a subsidiary of Parksons Packaging Ltd, India's largest printed packaging company, and operates a state-of-the-art facility in Dar es Salaam. Equipped with best-in-class KBA and Heidelberg machines—offering Conventional and UV printing, the first of its kind in Tanzania—our plant produces decorated cartons with film lamination, hot foiling, and precise finishing for superior shelf appeal.";

  const brandDetailParagraphs = [
    'We are equipped with automated die-cutting, folding, and gluing lines ensuring accuracy and consistency. We offer in-house pre-press and plate making, with advanced automated workflow from ESKO, for seamless colour management and faster turnaround.',
    'BRC audited and compliant, our facility meets the highest international standards for safety, quality, and hygiene in packaging manufacturing. We uphold transparency, quality governance, and global best practices, trusted by category leaders in Tobacco, FMCG, Food & Beverage, Personal Care, and Chemicals.',
    "With growing momentum in Tanzania, we are expanding exports to Zambia, Malawi, Kenya, Uganda, Mozambique, and South Africa—strengthening our position as East Africa's trusted printed packaging partner.",
    'Elevate your brand with world-class packaging from the house of Parksons.'
  ];

  const brandBulletPoints = [
    "Backed by Parksons Packaging India's six-decade legacy of innovation and quality.",
    'Best-in-class facility in Tanzania offering high-quality offset printed cartons.',
    'Local manufacturing with global quality standards.',
    'Faster turnaround times with lower inventory, working capital, and superior service.',
    'Proven expertise across regulated and high-demand industries.'
  ];


  return (
    <div className="about-ppl-tz-page">
      {/* Hero Image Section - Same as Home page */}
      <div className="hero-image-section">
        <img 
          src="/images/hero/hero-banner-factory.webp" 
          alt="Hero Banner" 
          className="hero-image"
        />
      </div>

      <div className="content-container fade-in">
        <div className="about-ppl-tz-hero-wrapper">
          <div className="about-ppl-tz-header">
            <button 
              className="back-button"
              onClick={() => navigate('/')}
              aria-label="Go back to home"
            >
              ← Back to Home
            </button>
          </div>

          <div className="about-ppl-tz-hero-section">
            <div className="about-ppl-tz-title-column">
              <h1>About Parksons Packaging Tanzania</h1>
            </div>
            <div className="about-ppl-tz-intro-column">
              <p>{brandIntroParagraph}</p>
            </div>
          </div>
        </div>

        <div className="about-ppl-tz-content">
          <div className="about-ppl-tz-section">
            <h2>Why Choose Parksons Packaging Tanzania</h2>
            <ul className="bullet-points">
              {brandBulletPoints.map((point, index) => (
                <li key={index}>{point}</li>
              ))}
            </ul>
          </div>

          <div className="about-ppl-tz-section">
            {brandDetailParagraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPPLTz;

